/** Muestra la dirección con mayúsculas/minúsculas legibles; no altera textos ya mixtos. */
export function formatStationAddressForDisplay(address) {
  const text = String(address ?? "").trim();
  if (!text) {
    return text;
  }

  const letters = text.replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñ]/g, "");
  if (letters.length === 0) {
    return text;
  }

  const upperCount = (text.match(/[A-ZÁÉÍÓÚÑ]/g) || []).length;
  const lowerCount = (text.match(/[a-záéíóúñ]/g) || []).length;
  if (lowerCount > 0 && upperCount / (upperCount + lowerCount) < 0.85) {
    return text;
  }

  const keepUpper = new Set([
    "c.p",
    "cp",
    "km",
    "s/n",
    "sn",
    "col",
    "col.",
    "av",
    "av.",
    "no",
    "n°",
    "nº",
    "intl",
    "int",
    "gral",
    "gral.",
    "cd",
    "cd.",
    "de",
    "del",
    "la",
    "las",
    "los",
    "y",
    "e",
    "por",
    "entre",
    "loc",
    "mz",
    "lt",
    "edo",
    "pte",
    "pto",
    "sur",
    "norte",
  ]);

  return text
    .split(/(\s+)/)
    .map((part) => {
      if (!part.trim()) {
        return part;
      }
      if (/^\d[\d.,+\-*/]*$/.test(part)) {
        return part;
      }

      const core = part.replace(/[.,;:!?]+$/, "");
      const suffix = part.slice(core.length);
      const key = core.toLowerCase();

      if (keepUpper.has(key)) {
        return core.toUpperCase() + suffix;
      }
      if (core.length <= 2 && /^[A-Za-zÁÉÍÓÚáéíóúÑñ.°º]+$/.test(core)) {
        return core.toUpperCase() + suffix;
      }

      return (
        core.charAt(0).toUpperCase() + core.slice(1).toLowerCase() + suffix
      );
    })
    .join("");
}
